module.exports = __webpack_public_path__ + "static/media/article2_slide2_main.507d2288.jpg";